import CertificationsApi from '@/store/api/certifications';

export default {
  namespaced: true,
  state: {
    certifications: [],
    selectedCertificate: null,
  },
  getters: {
    allCertifications(state) {
      return state.certifications;
    },
    selectedCertification(state) {
      return state.selectedCertificate;
    },

  },
  actions: {
    getCertificate(context, certificateId) {
      return new Promise((resolve, reject) => {
        CertificationsApi.verifyCertificate(certificateId)
          .then((response) => {
            context.commit('SET_SELECTED_CERTIFICATE', response);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    createCertificate(context, certificate) {
      return new Promise((resolve, reject) => {
        CertificationsApi.createCertificate(certificate)
          .then((response) => {
            context.commit('SET_SELECTED_CERTIFICATE', response);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    downloadCertificate(context, { certificate, download = true }) {
      return new Promise((resolve) => {
        CertificationsApi.downloadCertificate(certificate)
          .then((response) => {
            if (download) {
              const link = document.createElement('a');

              link.href = window.URL.createObjectURL(response.data);
              link.download = `certificate_${certificate._id}.pdf`;
              link.click();
            }

            resolve(response.data);
          });
      });
    },
    deleteCertificate(context, { certificate }) {
      return new Promise((resolve, reject) => {
        CertificationsApi.deleteCertificate(certificate)
          .then((response) => {
            context.commit('SET_SELECTED_CERTIFICATE', null);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
  mutations: {
    SET_CERTIFICATES(state, certificates) {
      state.certifications = certificates;
    },
    SET_SELECTED_CERTIFICATE(state, certificate) {
      state.selectedCertificate = certificate;
    },
  },
};
